import { Component, Input } from '@angular/core';
import { AccountService } from '../account.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
  selector: 'sign-up',
  templateUrl: './signUp.component.html',
  styleUrls: ['../account.scss', './signUp.component.scss'],
})
export class SignUpComponent {
  @Input() updateGuest;
  @Input() noPhotos;

  socialLogins = environment.socalLogins;

  errors = {
    username: '',
    password: '',
    first_name: '',
    last_name: '',
    terms: false,
  };

  isLoading;

  constructor(
    public accountService: AccountService,
    public activatedRoute: ActivatedRoute,
  ) {}

  setIsLoading(ev) {
    this.isLoading = ev;
  }

  setError(ev) {
    this.errors = ev;
  }

}
